import React, {useEffect} from 'react'
import classNames from 'classnames'
import { graphql, useStaticQuery } from 'gatsby'
import { WebinarCards, FutureWebinarsPanel } from 'newComponents'
import './styles.scss'

const webinarsQueries = graphql`
  query {
    ...WebinarsFragmentNew
  }
`

const Webinars = (props) => {
  useEffect(() => {
    const heightAdjust = () => {
      let maxHeight = 0
      const carousel = document.querySelectorAll('.future-webinar-panel-container > a')
      const container = document.querySelector('.future-webinar-panel-container')
      container.className += ' temp-visible'

      carousel.forEach((el) => {
        const elContainer = el.querySelector('.future-webinar-panel')
        elContainer.removeAttribute('style')
        if (elContainer.clientHeight > maxHeight) {
          maxHeight = elContainer.clientHeight
        }
      })

      carousel.forEach((el) => {
        const elContainer = el.querySelector('.future-webinar-panel')
        elContainer.setAttribute('style', `height: ${maxHeight}px;`)
      })
      container.classList.remove('temp-visible')
    }

    const onWindowResize = () => {
      heightAdjust()
    }

    if (document.querySelectorAll('.future-webinar-panel-container > a').length > 1) {
      let debounce
      window.addEventListener('resize', () => {
        clearTimeout(debounce)
        debounce = setTimeout(onWindowResize, 300)
      })

      setTimeout(() => {
        heightAdjust()
      }, 1000)
    }
  })

  const { hideFutureWebinars, confirmationPage } = props

  const data = useStaticQuery(webinarsQueries)

  const webinars = data?.allPrismicWebinar?.nodes || []

  const futureWebinars = webinars.filter((webinar) => !webinar.data.hidden && new Date() < new Date(webinar.data.date))
  const pastWebinars = webinars.filter((webinar) => !webinar.data.hidden && new Date() > new Date(webinar.data.date))

  const parseDate = (date) => parseInt(date?.data?.sortedDate || 0, 10)

  const sortedFutureWebinars = futureWebinars.sort((a, b) => (parseDate(a) > parseDate(b) ? -1 : 1))
  const sortedPastWebinars = pastWebinars.sort((a, b) => (parseDate(a) > parseDate(b) ? -1 : 1))

  return (
    <div className="bg-gradient-reverse section">
      {futureWebinars.length > 0 && !hideFutureWebinars && (
        <>
          <section className="section future-webinar-panel-section">
            <div className="container">
              <div className="has-text-centered-tablet">
                <h2 className="title title-black u-paddingsides-mobile">Upcoming Webinars</h2>
                <p className="subtitle u-paddingsides-mobile">Register for upcoming webinars.</p>
              </div>
            </div>
            <FutureWebinarsPanel futureWebinars={sortedFutureWebinars} />
          </section>
        </>
      )}
      <section className="section past-webinar-panel-section">
        <div className="container content">
          <div className="has-text-centered-tablet">
            <div
              className={classNames({
                'sections-border is-hidden-mobile': !!sortedFutureWebinars?.length
              })}
            />
            <h2 className="title u-paddingsides-mobile">On-Demand Webinars</h2>
            <p className="subtitle u-paddingsides-mobile">Missed a live session? Listen to the on-demand recording.</p>
          </div>
        </div>
        <div className="container content columns is-multiline cards">
          <WebinarCards
            webinars={{ future: sortedFutureWebinars, past: sortedPastWebinars }}
            confirmationPage={confirmationPage}
          />
        </div>
      </section>
    </div>
  )
}

export default Webinars
